import CTLDate from "application/components/CTLDate";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableDownloadBillPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "/extensionSummaryCDR/list",
  pdfDownload: "extensionSummaryCDR/generateAndDownloadPdf",
  csvDownload: "/extensionSummaryCDR/downloadCSV",
  // Pooled bill report (task #9574): poll status then download the finished PDF by id.
  reportStatus: "pdfReport/status",
  reportDownload: "pdfReport/download",
};

const getColumns = () => {
  return [
    {
      Header: "Extension No",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Extension Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Called Number",
      accessor: "destinationNumber",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Call Date Time",
      accessor: "datetimeIst",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      dateTime: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Call Type",
      accessor: "callType",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Direction",
      accessor: "coralCallDirection",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Talk Time(HH:MM:SS)",
      accessor: "talkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Pulse",
      accessor: "pulse",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Cost",
      accessor: "cost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
